import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { IPETest, PETestQuestion } from "../../data/interfaces"
import { ITestsStore, useTestsStore } from "../../data/store"
import useGenTest from "../../hooks/useGenTest"
import { Button, Intent } from "@blueprintjs/core"

const Cover = (): JSX.Element => {
    const genTest: IPETest = useGenTest()
    const getTests: IPETest[] = useTestsStore((state: ITestsStore) => state.genTests)
    
    const onField = (value: any, field: keyof PETestQuestion, data: any) => { 
        useTestsStore.setState({
            genTests : [
                ...getTests.map(gt => gt.id === genTest.id ? { ...gt, [field]: value } : gt )
            ]
        })
    }
    return <div className="px-3 w-100">
        <FieldInput
            editable
            type={SCALAR_TYPES.MEDIA}
            field="thumbnail"
            //title={__("Thumbnail")}
            value={genTest.thumbnail}
            onChange={onField}
            isURLHide
            notClear
            width={"100%"}
            height={200}
        />
       <FieldInput
            editable
            field="title"
            //title={__("Title")}
            value={genTest.title}
            placeholder={__("Write title")}
            onChange={onField}
        /> 
        <FieldInput
            editable
            type={SCALAR_TYPES.HTML}
            field="post_content"
            placeholder={__("Write description")}
            //title={__("Description")}
            value={genTest.post_content}
            onChange={onField}
        /> 

        <FieldInput
            editable
            type={SCALAR_TYPES.BOOLEAN}
            field="is_show_answer"
            placeholder="Show right answer after choose"
            title={__("Show right answer after choose")}
            value={genTest.is_show_answer}
            onChange={onField}
        /> 
        <FieldInput
            editable
            type={SCALAR_TYPES.BOOLEAN}
            field="is_show_results"
            placeholder="Show result after test"
            title={__("Show result after test")}
            value={genTest.is_show_results}
            onChange={onField}
        /> 
        <FieldInput
            editable
            type={SCALAR_TYPES.BOOLEAN}
            field="is_shuffle"
            placeholder="Shuffle Questions?"
            title={__("Shuffle Questions?")}
            value={genTest.is_shuffle}
            onChange={onField}
        /> 
        <FieldInput
            editable
            type={SCALAR_TYPES.BOOLEAN}
            field="is_timed"
            placeholder="With time limit"
            title={__("With time limit")}
            value={genTest.is_timed}
            onChange={onField}
        />  
        {
            genTest.is_timed &&
            <FieldInput
                editable
                type={SCALAR_TYPES.NUMBER}
                field="duration"
                placeholder="Duration per sec"
                title={__("Duration per sec")}
                min={0}
                postfix={__("secs")}
                value={genTest.duration}
                onChange={onField}
            /> 
        }
        
        <FieldInput
            editable
            type={SCALAR_TYPES.NUMBER}
            field="try_count"
            placeholder="try_count"
            title={__("try count")}
            value={genTest.try_count}
            min={0}
            postfix={__("times")}
            onChange={onField}
        /> 
    </div> 
}

export default Cover